"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMensagemParams = exports.yupMensagemParams = exports.schemaMensagem = exports.yupMensagem = void 0;
const yup = __importStar(require("yup"));
exports.yupMensagem = yup.object({
    idMensagemCategoria: yup.number().integer().required().label('Categoria da publicação'),
    texto: yup.string().default('').notRequired().nullable().label('Texto da publicação'),
    titulo: yup.string().default('').notRequired().nullable().label('Título da publicação'),
    rascunho: yup.boolean().required().default(false).label('Rascunho'),
    copiaEmail: yup.boolean().required().default(false).label('Enviar cópia por e-mail'),
    permiteResposta: yup.boolean().required().default(false).label('Permitir resposta'),
    respostaComAnexo: yup.boolean().required().default(false).label('Permitir resposta com anexo'),
    programarEnvio: yup.boolean().required().default(false).label('Programar para'),
    respostaAte: yup.date().default(null).nullable().notRequired().label('Responder até'),
    enviarEm: yup.date().default(null).nullable().notRequired().label('Enviar em'),
    idProfessor: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .notRequired()
        .nullable()
        .label('Professor'),
    idUsuario: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .notRequired()
        .nullable()
        .label('Professor'),
});
exports.schemaMensagem = exports.yupMensagem.shape({});
exports.yupMensagemParams = yup.object({
    texto: yup.string().default(undefined).notRequired().nullable().label('Texto da publicação'),
    rascunho: yup.boolean().notRequired().nullable().default(undefined).label('Rascunho'),
    professor: yup.boolean().notRequired().nullable().default(undefined).label('Enviado para professores'),
    dataIni: yup.date().default(undefined).nullable().notRequired().label('Data de inicio'),
    dataFim: yup.date().default(undefined).nullable().notRequired().label('Data de fim'),
    anoLetivo: yup.string().default(new Date().getFullYear().toString()).required().label('Texto da publicação'),
    idCurso: yup.number().default(undefined).notRequired().nullable().label('Curso'),
    idSerie: yup.number().default(undefined).notRequired().nullable().label('Série'),
    idTurma: yup.number().default(undefined).notRequired().nullable().label('Turma'),
    idMateria: yup.number().default(undefined).notRequired().nullable().label('Matéria'),
    idProfessor: yup.number().default(undefined).notRequired().nullable().label('Professor'),
    idMensagemCategoria: yup.number().default(undefined).notRequired().nullable().label('Categoria'),
});
exports.schemaMensagemParams = exports.yupMensagemParams.shape({});
